var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"align-center":""}},[_c('template',{slot:"header"}),_c('template',{slot:"content"},[_c('v-responsive',[_c('v-container',{attrs:{"fill-height":""}},[_c('br'),_c('div',{staticClass:"text-timeout"},[_c('p',{staticClass:"text-sm-left time"},[_vm._v(_vm._s(_vm.$t("text.timeout")))])])])],1)],1),_c('template',{slot:"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }